import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors, TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const lightTheme = {
  root: {
    '& $pagination': {
      '&.MuiTablePagination-root': {
        color: TextColors.dark,
      },

      '& .MuiIconButton-root:hover': {
        color: SecondaryColors.dark,
      },

      '& .MuiIconButton-root.Mui-disabled': {
        color: hexToRGBA(TextColors.dark, TextOpacities.dark3),
      },

      '& .MuiSelect-icon': {
        color: TextColors.dark,
      },

      '&.MuiPagination-root': {
        color: TextColors.dark,
      },
    },
  },
};
const darkTheme = {
  root: {
    '& $pagination': {
      '&.MuiTablePagination-root': {
        color: TextColors.light,
      },

      '& .MuiIconButton-root:hover': {
        color: SecondaryColors.main,
      },

      '& .MuiIconButton-root.Mui-disabled': {
        color: hexToRGBA(TextColors.light, TextOpacities.dark3),
      },

      '& .MuiSelect-icon': {
        color: TextColors.light,
      },

      '&.MuiPagination-root': {
        color: TextColors.light,
      },
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
      width: '100%',

      [muiTheme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
      },
    },
    printButtons: {
      [muiTheme.breakpoints.down('sm')]: {
        order: 3,
      },
    },
    wrapper: {
      width: '100%',

      [muiTheme.breakpoints.down('sm')]: {
        width: `calc(100% + ${muiTheme.spacing(8)}px)`,
        marginLeft: muiTheme.spacing(-4),
      },
    },
    pagination: {
      marginTop: muiTheme.spacing(2),
      marginRight: muiTheme.spacing(-2),

      '&.MuiTablePagination-root': {
        ...muiTheme.typography.body1,
      },

      '& .MuiIconButton-root:hover': {
        backgroundColor: 'transparent',
      },

      [muiTheme.breakpoints.down('sm')]: {
        '& .MuiToolbar-root': {
          'flex-direction': 'column',
        },
      },

      '&.MuiPagination-root': {
        margin: '0',
      },

      '& .MuiPaginationItem-root': {
        color: 'inherit',
      },
    },
    spacer: {
      '&.MuiTablePagination-spacer': {
        flex: 1,
      },
      [muiTheme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  }),
  { name: 'GenSDLTable' },
);

export default useStyles;
